import React, {useState} from "react"
import {Popover} from "antd"
import cx from "classnames"
import {Icon} from "components/Icon"
import {chatServiceV2} from "services"
import {handleError} from "helpers"
import {BaseLoading} from "components/Loading"
import {Notifications} from "./Notifications"
import styles from "./Notification.module.css"
import {useQuery} from "@tanstack/react-query"

export function Notification() {
    const [visible, setVisible] = useState(false)

    const unreadCountQuery = useQuery(["notification-unread"], () => chatServiceV2.unreadNotifications(), {
        select: (resp) => {
            const {unread} = resp || {}
            return unread || 0
        },
        onError: (err) => {
            handleError(err)
        },
        staleTime: 1000 * 60, // 1 minute
        refetchOnMount: true
    })

    const renderNotifications = () => {
        if (unreadCountQuery.isLoading) {
            return (
                <div>
                    <BaseLoading isShow />
                </div>
            )
        }
        return <Notifications onFetchUnreadCount={unreadCountQuery.refetch} onClose={() => onVisibleChange(false)} />
    }

    const onVisibleChange = (newVisible: boolean) => {
        setVisible(newVisible)
    }

    return (
        <Popover
            visible={visible}
            trigger="click"
            placement="bottomRight"
            content={renderNotifications}
            onVisibleChange={onVisibleChange}>
            <div className={cx(styles.notificationWrap, {[styles.notificationWrap__opened]: visible})}>
                <Icon icon="BELL_LINE" className={styles.notificationIcon} color={visible ? "#fff" : "#1e90ff"} />
                {unreadCountQuery.data > 0 && !visible && <div className={styles.notificationUnread} />}
            </div>
        </Popover>
    )
}
